/* eslint-disable no-extra-parens */
import { JSONSchema7 } from 'json-schema';
import { customSchemas, types as commonTypes } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import List from './List';

export const listSchema: JSONSchema7 = {
    title: 'List',
    type: 'object',
    required: [],
    properties: {
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        titles: headingsSchema,
        dataKey: {
            type: 'string',
            title: 'Enter list data key',
            description: 'Data key for list',
        },
        itemDataKey: {
            type: 'string',
            title: 'Enter list item data key',
            description: 'Enter handlebar value for list item data key',
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['titles', 'dataKey', 'itemDataKey'],
    },
];

const ListWidget: commonTypes.IWidget = {
    schema: listSchema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        titles: {
            items: {
                headerText: {
                    'ui:widget': 'ResourcePicker',
                },
            },
        },
    },
    templateView: List,
    id: 'List',
    group: 'component',
    contentPlaceHolders: [],
    initialData: () => ({}),
};

export default ListWidget;
